import { cva } from 'class-variance-authority';
import { cn } from 'common/utils';
import React, { useRef, useState } from 'react';
import { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';

const Tooltip = ({
  content,
  alignment,
  placement = 'bottom',
  children,
  open,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState(null);
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  const tooltipVariants = cva(
    ['relative flex flex-1', { 'cursor-pointer': content }],
    {
      variants: {
        alignment: {
          start: 'justify-start',
          center: 'justify-center',
          end: 'justify-end',
        },
      },
      defaultVariants: {
        alignment: 'center',
      },
    },
  );

  useLayoutEffect(() => {
    if (showTooltip && triggerRef.current && tooltipRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const tooltipWidth = tooltipRef.current.offsetWidth;
      const tooltipHeight = tooltipRef.current.offsetHeight;
      let newTop =
        placement === 'top'
          ? rect.top + window.scrollY - 8 - tooltipHeight
          : rect.bottom + window.scrollY + 8;
      let newLeft = rect.left + window.scrollX;
      // Se em 'top' e saiu fora do topo, faz fallback para bottom
      if (placement === 'top' && newTop < window.scrollY + 8) {
        newTop = rect.bottom + window.scrollY + 8;
      }

      if (newLeft + tooltipWidth > window.innerWidth) {
        newLeft = window.innerWidth - tooltipWidth - 8;
      }
      if (newLeft < 8) newLeft = 8;
      setPosition({ top: newTop, left: newLeft });
    }
  }, [showTooltip, alignment, placement, content]);

  return (
    <div className={cn(tooltipVariants({ alignment }))}>
      <div
        ref={triggerRef}
        onClick={() => setShowTooltip(open ?? !showTooltip)}
        onMouseEnter={() => setShowTooltip(open ?? true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
      </div>
      {showTooltip &&
        content &&
        ReactDOM.createPortal(
          <div
            ref={tooltipRef}
            className={cn(
              'absolute shadow w-max',
              'bg-raisin-black text-white rounded p-2',
              'pointer-events-none z-50',
              'text-xs font-semibold',
            )}
            style={{
              top: position?.top,
              left: position?.left,
              visibility:
                position?.top || position?.left ? 'visible' : 'hidden',
            }}
          >
            {content}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Tooltip;
